/**
 * File sizes for the document rows.
 *
 * Liquid's generic_file carries no size, so the server cannot print one. The
 * CDN does send Content-Length and allows the read (access-control-allow-origin
 * is *, and Content-Length is CORS-safelisted), so the browser can ask for it
 * with a HEAD request that downloads no body.
 *
 * A field tech on mobile data decides with this number, so it is worth the
 * round trip — but the row is complete without it. Every failure is silent and
 * the empty span collapses.
 */
(() => {
  const CONCURRENCY = 4;

  const format = (bytes) => {
    if (!Number.isFinite(bytes) || bytes <= 0) return '';
    if (bytes < 1024) return `${bytes} B`;
    const mb = bytes / (1024 * 1024);
    if (mb < 1) return `${Math.round(bytes / 1024)} KB`;
    if (mb < 10) return `${mb.toFixed(1)} MB`;
    return `${Math.round(mb)} MB`;
  };

  const measure = async (node) => {
    const url = node.dataset.docSize;
    if (!url) return;
    try {
      const response = await fetch(url, { method: 'HEAD' });
      if (!response.ok) return;
      const size = format(Number(response.headers.get('content-length')));
      if (size) node.textContent = size;
    } catch {
      // Offline, blocked, or a CDN that stopped answering: leave the row alone.
    }
  };

  const run = async () => {
    const queue = [...document.querySelectorAll('[data-doc-size]')];
    const workers = Array.from({ length: Math.min(CONCURRENCY, queue.length) }, async () => {
      let node;
      while ((node = queue.shift())) await measure(node);
    });
    await Promise.all(workers);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
